<form #modal [formGroup]="form">
    <div class="modal-header">
        <h2 class="headline m-0" fxFlex="auto">{{"write_review"|translate}}</h2>
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
        </button>
    </div>

    <div class="modal-body">
        <div class="form-group required">
            <label class="control-label">{{"name"|translate}}</label>
            <input formControlName="name" class="form-control form-control-sm" required>
        </div>
        <div class="form-group required">
            <label class="control-label">{{"your_rating"|translate}}</label>
            <rating formControlName="rating" class="form-control -ms-4 no-border" [max]=5 [customTemplate]="ct">
            </rating>
            <ng-template #ct let-index="index" let-value="value">
                <span class="star" [class.filled]="index < value">&#9733;</span>
            </ng-template>
        </div>
        <div class="form-group">
            <label class="control-label">{{"your_review"|translate}}</label>
            <textarea formControlName="review" rows="3" class="form-control form-control-sm"></textarea>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="save()">{{"submit"|translate}}</button>
    </div>
</form>
